import {
  Challenge,
  ConstantsNameDescriptions,
  ContentSetting,
  ContentSettingV2,
  Encounter,
  Exercise,
  Goal,
  Patient,
  ResourceSetting,
} from '_api/types';
import { ModalProps } from 'components/organisms/modals/types';
import { HeaderMenuOption } from 'components/templates/types';
import { MRT_ColumnDef } from 'material-react-table';
import { CSSProperties, ReactNode } from 'react';

export type ActionFlexBoxProps = {
  msg?: string;
  activateOnClick?: () => void;
  addOnClick?: () => void;
  addPatientOnClick?: () => void;
  archiveOnClick?: () => void;
  completeOnClick?: () => void;
  downloadOnClick?: () => void;
  deleteOnClick?: () => void;
  editOnClick?: () => void;
  reportOnClick?: () => void;
  viewOnClick?: () => void;
  openInNewOnClick?: () => void;
  actionButtons: ViewButtons;
  disableAll?: boolean;
  disableComplete?: boolean;
  disableEdit?: boolean;
  disableDelete?: boolean;
  disableDeleteTooltip?: string;
  disableEditTooltip?: string;
};

export type AddToPatientProfileHeaderProps = {
  title: string;
  imageUrl: any;
};

export type AlertMessageProps = {
  message: string | ReactNode;
  open: boolean;
  severity?: AlertMessageSeverity;
  onClose: () => void;
  hideDuration?: number;
};

export type AlertMessageSeverity = 'error' | 'success';

export type BaseModalProps = ModalProps & {
  title: string;
  children: ReactNode;
  footer?: ReactNode | (() => ReactNode);
  maxWidth?: 'xl' | 'lg' | 'sm' | 'xs';
};

export type FileAttachmentButtonProps = {
  disabled: boolean;
  onFileSelect: (file: string) => void;
  isUploadingFile: (value: boolean) => void;
  setFileName: (name: string) => void;
};

export type FileExtention =
  | 'audio/mpeg'
  | 'audio/wav'
  | 'audio/aac'
  | 'audio/mp4'
  | 'audio/ogg'
  | 'image/jpeg'
  | 'image/jpeg'
  | 'image/png'
  | 'image/gif'
  | 'text/plain'
  | 'application/zip'
  | 'application/pdf'
  | 'video/mp4'
  | 'video/quicktime'
  | 'video/mpeg'
  | 'video/mpeg';

export const FILE_EXTENSION_TO_MIME_MAP: { [k: string]: FileExtention } = {
  mp3: 'audio/mpeg',
  wav: 'audio/wav',
  aac: 'audio/aac',
  m4a: 'audio/mp4',
  ogg: 'audio/ogg',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  txt: 'text/plain',
  zip: 'application/zip',
  pdf: 'application/pdf',
  mp4: 'video/mp4',
  mov: 'video/quicktime',
  mpg: 'video/mpeg',
  mpeg: 'video/mpeg',
};

export type HeaderMenuProps = {
  anchorEl: null | HTMLElement;
  handleClose: () => void;
  options: HeaderMenuOption[];
  title: string;
};

export type PatientProfileTableProps = {
  data:
    | ContentSetting<Challenge>[]
    | ContentSettingV2<Challenge>[]
    | ContentSetting<Exercise>[]
    | ContentSettingV2<Exercise>[]
    | ResourceSetting[]
    | Goal[]
    | any[];
  children?: ReactNode;
  columns:
    | MRT_ColumnDef<ContentSetting<Challenge>, any>[]
    | MRT_ColumnDef<ContentSettingV2<Challenge>, any>[]
    | MRT_ColumnDef<ContentSetting<Exercise>, any>[]
    | MRT_ColumnDef<ContentSettingV2<Exercise>, any>[]
    | MRT_ColumnDef<ResourceSetting, any>[]
    | MRT_ColumnDef<Goal, any>[]
    | MRT_ColumnDef<Encounter, any>[];
  onAddClick: () => void;
  title: string;
};

export type SelectProps = {
  disabled?: boolean;
  initValue: string;
  label?: string;
  onUpdate: (newValue: string) => void;
  options: Array<ConstantsNameDescriptions<string>>;
  selectStyle?: CSSProperties;
};

export type ViewButtons = {
  activateButton?: boolean;
  addButton?: boolean;
  addPatient?: boolean;
  archiveButton?: boolean;
  completeButton?: boolean;
  downloadButton?: boolean;
  editButton?: boolean;
  deleteButton?: boolean;
  reportButton?: boolean;
  viewButton?: boolean;
  openNewTabButton?: boolean;
};

export interface ViewProfileMenuProps {
  patients: Patient[];
}
